<template>
  <div class="container">
    <breadcrumbs></breadcrumbs>
    <title-block title="Voeg Foto Toe" :callback="GetOrRefreshData()"></title-block>
    <div class="field is-horizontal custom">
      <div class="field">
        <label class="label">Project</label>
      </div>
      <div class="field">
        <b-select placeholder="Selecteer een project" @input="projectChangedHandler">
          <option v-for="project in projects" :value="project" :key="project.projectId">{{ project.name }}</option>
        </b-select>
      </div>
      <div class="field">
        <label class="label" style="width:133.25px">QR-Code Opening</label>
      </div>
      <div class="field">
        <!-- style="width: 15rem;"> -->
        <b-input type="number" v-model="qrCode" required></b-input>
      </div>

      <div class="field">
        <div class="control">
          <button
            @click="
              search()
              photosVisible = true
            "
            class="button is-primary"
          >
            Zoek QR-Code
          </button>
        </div>
      </div>
    </div>
    <div class="field is-horizontal" v-if="hasError">
      <div class="field-body">
        <div class="field">
          <div class="control">
            <br />
            <b-message title="Success" type="is-danger">QR-Code does not exist</b-message>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="columns" v-if="existOpening">
      <div class="column">
        <p class="is-size-5 has-text-primary">Foto's</p>
        <div id="photo">
          <table class="opening-table" style="width:100%" v-if="photos.length > 0">
            <tr>
              <th>Datum</th>
              <th>Status</th>
            </tr>
            <tr
              class="clickable-tablerow"
              v-for="(photo, index) in photos"
              :key="index"
              :class="{ isSelectedPhotoRow: photo == selectedPhoto }"
              @click="
                addPhoto = false
                showPhoto = true
                setSelectedPhoto(photo)
              "
            >
              <td>{{ new Date(photo.captureTime).toLocaleDateString('nl-NL') }}</td>
              <td>{{ options[photo.registrationType] }}</td>
            </tr>
            <tr
              class="clickable-tablerow"
              @click="
                addPhoto = true
                showPhoto = false
                selectedPhoto = ''
              "
            >
              <td>...</td>
              <td>Klik hier om een nieuw foto te uploaden</td>
            </tr>
          </table>

          <p v-else>Geen foto's</p>
        </div>
      </div>

      <div class="column" v-if="!addPhoto & showPhoto">
        <div v-if="selectedPhoto" class="selectedPhoto custom">
          <p class="is-size-5 has-text-primary">Details Geselecteerde Foto</p>
          <div class="columns">
            <div class="column">
              <table class="printblock-table">
                <tr>
                  <td>Datum:</td>
                  <td>{{ new Date(selectedPhoto.captureTime).toLocaleDateString('nl-NL') }}</td>
                </tr>
                <tr>
                  <td>Gebruiker:</td>
                  <td>{{ selectedPhoto.captureUser }}</td>
                </tr>
                <tr>
                  <td>Status:</td>
                  <td colspan="3">{{ options[selectedPhoto.registrationType] }}</td>
                </tr>
                <tr>
                  <td>Commentaar:</td>
                  <td colspan="3">{{ selectedPhoto.comment }}</td>
                </tr>
              </table>
            </div>
            <div class="column">
              <img :src="selectedPhoto.uri" @click="showPhotoModal = true" class="photoHover" />
            </div>
          </div>
        </div>
      </div>
      <div class="column" v-if="addPhoto & !showPhoto">
        <p class="is-size-5 has-text-primary">Upload Uw Foto:</p>
        <div class="columns">
          <div class="column">
            <b-field class="custom-upload">
              <b-upload v-model="dropFiles" @input="imagePreview" drag-drop accept="image/*">
                <section class="section">
                  <div class="content has-text-centered" v-if="dropFiles.length == 0">
                    <p>
                      <b-icon icon="upload" size="is-large"></b-icon>
                    </p>
                    <p>Drop your files here or click to upload</p>
                  </div>
                  <div v-if="dropFiles.length != 0">
                    <div class="file-listing">
                      <img class="preview" ref="preview" />
                    </div>
                  </div>
                </section>
              </b-upload>
            </b-field>
            <!-- <div id="app">
              <vue-dropzone ref="vueDropzone" id="customdropzone" :options="dropOptions"></vue-dropzone>
            </div>-->
          </div>
          <div class="column">
            <br />
            <b-field label="Status">
              <b-select placeholder="Selecteer een Status" v-model="selectedStatus">
                <option v-for="option in options" :key="option">{{ option }}</option>
              </b-select>
            </b-field>
            <b-field label="Commentaar">
              <b-input maxlength="200" type="textarea" style="width:280px" v-model="comment"></b-input>
            </b-field>
            <a class="button is-dark custom" @click="deleteDropFile()">Reset</a>
            <a class="button is-primary custom" @click="submitFiles()" :disabled="this.photo == ''">Save</a>
          </div>
        </div>
      </div>
    </div>

    <!-- <div id="file-drag-drop">
      <form ref="fileform">
        <span class="drop-files">Drop the files here!</span>
      </form>
      <div v-for="(file, key) in files" :key="key" class="file-listing">
        <img class="preview" v-bind:ref="'preview'+parseInt( key )">
        {{ file.name }}
        <div class="remove-container">
          <a class="remove" v-on:click="removeFile( key )">Remove</a>
        </div>
      </div>

      <a class="submit-button" v-on:click="submitFiles()" v-show="files.length > 0">Submit</a>
    </div>
    <form class="box" :class="{'has-advanced-upload': dragAndDropCapable}" ref="fileform">
      <span class="drop-files">Drop the files here!</span>
      <div class="box__input">
        <input
          class="box__file"
          type="file"
          name="files[]"
          id="file"
          data-multiple-caption="{count} files selected"
          multiple
        >
        <label for="file">
          <strong>Choose a file</strong>
          <span class="box__dragndrop">or drag it here</span>.
        </label>
        <button class="box__button" type="submit">Upload</button>
      </div>
    </form>-->
    <!-- 
    <section>
      <div class="remove-container">
        <a class="remove" v-on:click="deleteDropFile()">Remove</a>
        <a class="submit-button" v-on:click="submitFiles()" v-show="dropFiles.length > 0">Submit</a>
      </div>
      <div class="tags">
        <span v-for="(file, index) in dropFiles" :key="index" class="tag is-primary">
          {{ file.name }}
          <button
            class="delete is-small"
            type="button"
            @click="deleteDropFile(index)"
          ></button>
        </span>
      </div>
    </section>-->
  </div>
</template>

<script>
import Breadcrumbs from '../General/Breadcrumbs'
import TitleBlock from '../General/TitleBlock'
import ProjectService from '@/services/projectService.js'
import openingService from '@/services/openingService'
import vueDropzone from 'vue2-dropzone'

export default {
  components: {
    Breadcrumbs,
    TitleBlock,
    vueDropzone
  },
  data() {
    return {
      showPhoto: false,
      comment: '',
      photo: '',
      selectedStatus: 0,
      options: [
        'Geen',
        'Offerteopname: geen QR',
        'Vooropname: niet akkoord',
        'Vooropname: akkoord',
        'Montage: niet akkoord',
        'Montage: akkoord',
        'Inspectie: akkoord',
        'Inspectie: niet akkoord',
        'Inspectie periodiek: akkoord',
        'Mutatie: reparatie/herstel'
      ],
      projects: [],
      selectedProject: [],
      qrCode: '',
      photosVisible: false,
      selectedOpeningId: [],
      photos: [],
      isSelectedPhotoRow: '',
      selectedPhoto: '',
      image: '',
      hasError: false,
      dropOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        maxFiles: 1
      },
      existOpening: false,
      addPhoto: false,
      dragAndDropCapable: false,
      uploadPercentage: 0,
      dropFiles: []
    }
  },

  beforeCreate() {
    ProjectService.getProjectList().then(res => {
      this.projects = res.data.projects
    })
  },

  methods: {
    deleteDropFile() {
      this.dropFiles = []
      this.photo = ''
      this.selectedStatus = ''
      this.comment = ''
    },
    GetOrRefreshData() {},
    async search() {
      console.log(
        `%cstarted search to opening ${this.qrCode} in project ${this.selectedProject.projectId}`,
        'color:yellow;'
      )
      let res = ''
      try {
        res = await openingService.getOpeningByTag(this.selectedProject.projectId, this.qrCode)
      } catch (error) {
        if (error.toString().includes('404')) {
          this.hasError = true
          this.existOpening = false
          console.error('QR-code does not exist')
        }
        return
      }
      if (res.status == 200) {
        this.selectedOpeningId = res.data.openingId
        const res2 = await openingService.getPhotosByOpening(this.selectedProject.projectId, this.selectedOpeningId)
        console.log('%cOpening Found', 'color:yellow;')
        this.photos = res2.data.photos
        this.hasError = false
        this.existOpening = true
      } else {
        this.hasError = true
        this.existOpening = false
      }
    },
    projectChangedHandler(value) {
      this.projectId = value.projectId
      ProjectService.getProject(value.projectId).then(res => {
        this.selectedProject = res.data
      })
    },
    setSelectedPhoto(photo) {
      this.selectedPhoto = photo
    },

    imagePreview: function(event) {
      const input = event
      if (event != null) {
        // if (/\.(jpe?g|png|gif)$/i.test(this.dropFiles[i].name)) {
        const reader = new FileReader()
        reader.onload = e => {
          this.$refs['preview'].src = reader.result
          this.photo = reader.result
        }

        reader.readAsDataURL(input)
        // } else {
        //   this.$nextTick(function() {
        //     this.$refs['preview' + parseInt(i)][0].src = '/images/file.png'
        //   })
      }
    },
    //todo const file is unused
    async submitFiles() {
      if (this.photo != '') {
        const data = this.photo.split(',')[1]
        const photoInfo = {
          photo: data,
          comment: this.comment,
          RegistrationType: this.options.findIndex(o => o == this.selectedStatus)
        }
        const res = await openingService.addPhotoOpening(this.projectId, this.selectedOpeningId, photoInfo)
      }
    },

    /*
        Removes a select file the user has uploaded
      */
    removeFile(key) {
      this.files.splice(key, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
#customdropzone {
  width: 280px;
  height: 280px;
  margin-top: 25px;
  margin-bottom: 15px;
}
// .customtitle {
//   .modaltitle {
//     margin-right: 80px;
//   }
// }
.button.is-primary.custom {
  margin-top: -20px;
}
.button.is-dark.custom {
  margin-top: -20px;
}
.field.is-horizontal.custom * {
  margin-right: 1rem;
  max-width: 15rem;
}
.field.is-horizontal.custom {
  .label {
    margin-top: 0.3rem;
    margin-right: 0rem;
  }
}
.selectedPhoto.custom {
  margin-top: 0px;
  // border: 2px solid hotpink;
  width: 100%;
  height: auto;
  img {
    width: auto;
    height: auto;
    max-height: 400px;
  }
  form {
    display: block;
    height: 400px;
    width: 400px;
    background: #ccc;
    margin: auto;
    margin-top: 40px;
    text-align: center;
    line-height: 400px;
    border-radius: 4px;
  }

  div.file-listing {
    width: 400px;
    margin: auto;
    padding: 10px;
    border-bottom: 1px solid #ddd;
  }

  div.file-listing img {
    height: 100px;
  }

  div.remove-container {
    text-align: center;
  }

  div.remove-container a {
    color: red;
    cursor: pointer;
  }

  a.submit-button {
    display: block;
    margin: auto;
    text-align: center;
    width: 200px;
    padding: 10px;
    text-transform: uppercase;
    background-color: #ccc;
    color: white;
    font-weight: bold;
    margin-top: 20px;
  }

  progress {
    width: 400px;
    margin: auto;
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .box__dragndrop,
  .box__uploading,
  .box__success,
  .box__error {
    display: none;
  }
  .box.has-advanced-upload {
    background-color: green;
    outline: 2px dashed black;
    outline-offset: -10px;
  }
  .box.has-advanced-upload .box__dragndrop {
    display: inline;
  }
  .box.is-dragover {
    background-color: grey;
  }
}
.custom-upload {
  padding-top: 30px;
  .section {
    padding: 5rem 1.5rem;
  }
}
/* ... */
</style>



// WEBPACK FOOTER //
// src/components/Projects/AddPhoto.vue